const btnMenuOpen = document.querySelector('#menuOpen');
const menu = document.querySelector('#menu');
const btnMenuClose = document.querySelector('#menuClose');
//const submenu = document.querySelectorAll('.menu-mobile-list .hasSubmenu');

export default class MenuToggle {
  static toggle = function () {
    btnMenuOpen.addEventListener('click', function () {
      console.log('click');
      //toggle modal
      menu.classList.contains('open')
        ? (menu.classList.remove('open'),
          (document.documentElement.style.overflow = 'auto'))
        : (menu.classList.add('open'),
          (document.documentElement.style.overflow = 'hidden'));
    });
    btnMenuClose.addEventListener('click', function () {
      menu.classList.remove('open');
      document.documentElement.style.overflow = 'auto';
    });
  };

  static toggleSubmenu = function () {
    const firstNavItem = document.querySelector('.principal .nav-item:first-child');
    const firstNavLink = firstNavItem
      ? firstNavItem.querySelector('.nav-link')
      : null;
    const dropdownMenu = firstNavItem
      ? firstNavItem.querySelector('.dropdown-menu')
      : null;
    const mobileQuery = window.matchMedia('(max-width: 480px)');

    if (!firstNavItem || !firstNavLink || !dropdownMenu) {
      return;
    }

    firstNavLink.setAttribute('aria-expanded', 'false');

    firstNavLink.addEventListener('click', function (e) {
      if (!mobileQuery.matches) {
        return;
      }
      e.preventDefault();
      const isOpen = firstNavLink.classList.toggle('open');
      dropdownMenu.classList.toggle('open', isOpen);
      firstNavLink.setAttribute('aria-expanded', isOpen);
    });
  };

  static init() {
    MenuToggle.toggle();
    MenuToggle.toggleSubmenu();
  }
}
